/* eslint-disable */
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'
import { buildParamsWithAuthPolicy } from './photo'

/**
 * AI问照片「照片地图」区域聚合
 *
 * 与 v5 卡片严格同源:filter 直接用卡片当前的搜索筛选(selectSearchFilter),
 * 再经 buildParamsWithAuthPolicy 注入「看照片范围」(部门/人员),保证地图张数与卡片一致。
 * 后端 /web/address/v1/photo/map_agg 走 photosearch GetPhotoRegionAggV2,
 * 一次返回 区县→POI 的「计数 + 坐标(已转 GCJ02)+ 封面」树。
 *
 * @param {Object} data
 * @param {string} data.groupID 团队真实 ID
 * @param {Object} data.filter 与卡片同一份搜索筛选条件
 * @param {string} [data.level] 聚合层级 city/district/poi;point=明细打点(排行气球);默认 district
 * @param {string} [data.districtName] 下钻父级区县名(level=poi 时传)
 * @param {number} [data.pointLimit] level=point 时返回照片点上限
 * @param {string} [data.poiName] level=point 且指定时:只返回该 POI 的照片点
 */
export function fetchPhotoMapAgg(data) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/address/v1/photo/map_agg',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // map_agg 与 v5 /v5/workgroup/photos 同款,返回 { status, payload }(status 0 成功);
        // 不是 {data,msg,code} 信封,别用 exceptionHelper(它读 result.data 会拿到 undefined 然后报错)。
        if (result && result.status === 0) {
          return result.payload
        }
        return Promise.reject(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}

/**
 * 照片地图「免费体验一次」消费:VVIP 以下用户首次打开地图前调一次。
 * 后端 POST /web/address/v1/photo/map_trial(自己从 cookie 取 userID + 校验成员),
 * 返回 { firstTime }:
 *   - firstTime=true  本次为首次免费体验(放行,关闭地图时提示"体验结束")
 *   - firstTime=false 已用过(同一团队),引导开通会员
 * @param {string} groupID 团队真实 ID
 */
export function consumeMapTrial(groupID) {
  return (dispatch, getState) => {
    const config = {
      url: __API_SERVER_HOST__ + '/web/address/v1/photo/map_trial',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ groupID })
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result && result.status === 0) {
          return result.payload || {}
        }
        return Promise.reject(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
  }
}
